export default {
  path: 'partner-locations/:id',
  name: 'PartnerLocation',
  component: () => import(/* webpackChunkName: "administration" */ '../views/PartnerLocationView.vue')
}
